import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OccurrenceForm.html?raw';
import HintBox from '../../moreCore/UI/EntityBased/HintBox/HintBox';

import EntitySelect from '../../moreCore/UI/EntityBased/EntitySelect/EntitySelect';
import "./OccurrenceFMtype";
import OccurrencePropertiesTable from '../Occurrence/OccurrencePropertiesTable/OccurrencePropertiesTable';

    type OccurrenceFMForm__mdsbase = InstanceType<typeof _WidgetBaseSP>;
interface OccurrenceFMForm extends OccurrenceFMForm__mdsbase { }
    class OccurrenceFMForm {
        templateString;

        entityID: string;
        entityGUID: string;
        jsonEntity; // Entity wies aus der Datenbank kommt
        mainOccurrence;
        continuousSaveMode: boolean; // wenn true werden Datenänderungen immer gleich in die Datenbank zurückgespielt
        isDirty: boolean;
        _formDataUndirty: any;

        selectedRoomID: string;
        selectedLevelID: string;
        selectedBuildingID: string;
        selectedBuildingPartID: string;
        isAreaNeeded: number | boolean;
        additionalLocations;

        isSpecialConfirmationNeeded: boolean;
        _specialConfirmationStatus;

        startupState: string;
        errorCallback;
        successCallback;

        occurrenceTypesData;

        employee;
        currentReporterEntity;
        _tmpSelectedReporterEntity;
        _tmpReporterHintbox;
        _enableChangeReporter: boolean;
        _isEditor: boolean;

        readonly;

        inputEscalation: HTMLInputElement;
        buttonSelectRoom: HTMLButtonElement;
        inputComment: HTMLInputElement;
        inputDate: HTMLInputElement;
        inputCostCenter: MdsLax<InstanceType<typeof HintBox>>;
        inputOccurrenceType: MdsLax<InstanceType<typeof EntitySelect>>;
        btnEditReporter: HTMLButtonElement;
        inputReporter: HTMLInputElement;
        inputFeedback: HTMLInputElement;
        containerRoom: HTMLDivElement;
        sectionAdditionalLocation: HTMLDivElement;
        additionalLocationsContainer: HTMLDivElement;
        sectionEscalation: HTMLDivElement;
        editReporterContainer: HTMLDivElement;
        sectionTasks: HTMLDivElement;
        selectAdditionalLocationsContainer: HTMLDivElement;
        sectionProperties: HTMLDivElement;
        sectionPhoneNo: HTMLDivElement;
        sectionMPhoneNo: HTMLDivElement;
        sectionChilds: HTMLDivElement;
        sectionSpecialInfo: HTMLDivElement;
        sectionEditorInfo: HTMLDivElement;
        sectionFeedback: HTMLDivElement;
        sectionNotes: HTMLDivElement;
        sectionCancellationInfo: HTMLDivElement;
        sectionMainOccurrence: HTMLDivElement;
        MPhoneNoLabel: HTMLElement;
        PhoneNoLabel: HTMLElement;
        labelMainOccurrence: HTMLElement;
        txtSpecialConfirmation: HTMLElement;
        txtSpecialNote: HTMLElement;
        tableSpecialNote: HTMLElement;
        tableSpecialConfirmation: HTMLElement;
        buttonCheckSpecialConfirmation_Unchecked: HTMLElement;
        buttonCheckSpecialConfirmation_Checked: HTMLElement;
        btnConfirmReporter: HTMLButtonElement;
        btnCancelReporter: HTMLButtonElement;
        inputCostCenterEmployee: HTMLInputElement;
        labelRoom: HTMLInputElement;
        propertiesTable: MdsLax<InstanceType<typeof OccurrencePropertiesTable>>;

        
        //// Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
        //formData: OccurrenceFM.formData = {
        //    _dataFormatVersion: 3, // falls die API auf eine neue Version reagieren muss während Updates!
        //    buildingID: null,
        //    buildingPartID: null,
        //    roomID: null,
        //    levelID: null,
        //    additionalLocations: [],
        //    reporterID: null,
        //    costCenterID: null,
        //    occurrenceTypeID: null,
        //    dateOfRecord: null,
        //    isEscalation: null,
        //    comment: null,
        //    specialConfirmation: null,
        //    propertyData: null, // Tabulator, alt, blöd, buuhh!
        //    properties: null, // neue Tabelle ab 2021!!
        //    mainOccurrenceID: null,
        //    _propertyAttributeHelper: "value_text_global" // temporär! wir müssen von value_text auf _global umschalten und die API kennt sich sonst nicht aus...
        //};

        //postMixInProperties(): void {
        //    let self: any = this;
        //    self.inherited(arguments);
        //}
        //postCreate(): void {
        //    let self: any = this;
        //    self.inherited(arguments);
        //    this.RequestManager.silentExceptions = true;
        //}

        //_setReadonlyAttr(value) {
        //    if (value != true && value != false) {
        //        value = this.readonly;
        //    }
        //    this.readonly = value;
        //    //console.log("setreadonly", value);

        //    //  Eskalationscheckbox
        //    // Sonderregeln, werden in der API gesteuert
        //    let allowEscalation: boolean = false;
        //    if (this.jsonEntity != null) {
        //        allowEscalation = this.jsonEntity.canEscalate == true;
        //    }
        //    if (allowEscalation === true) {
        //        //console.debug("allow escalation");
        //        this.UiModder.domAttr.remove(this.inputEscalation, "disabled");
        //    } else {
        //        //console.debug("disable escalation");
        //        this.UiModder.domAttr.set(this.inputEscalation, "disabled", !allowEscalation);
        //    }

        //    // Reporter editierbar?
        //    this._setEditReporterVisibility();

        //    // zusätzliche Locations wählbar?
        //    let occurrenceType = null;
        //    if (this.jsonEntity != null) {
        //        occurrenceType = this.jsonEntity.ref_occurrence_type;
        //    }
        //    this._setAdditionalLocationsVisibility(occurrenceType);


        //    //if (this.readonly == true) {
        //    //    this.UiModder.domClass.add(this.btnSendNote, "w3-hide");
        //    //} else {
        //    //    this.UiModder.domClass.remove(this.btnSendNote, "w3-hide");
        //    //}

        //    //  Raumauswahl
        //    //
        //    if (this.buttonSelectRoom != null) {
        //        this.UiModder.domAttr.set(this.buttonSelectRoom, "disabled", this.readonly);
        //        let domClassFct = this.readonly == true ? this.UiModder.domClass.remove : this.UiModder.domClass.add;
        //        domClassFct(this.buttonSelectRoom, "mds-hover-bright");

        //        domClassFct = this.readonly == true ? this.UiModder.domClass.add : this.UiModder.domClass.remove;
        //        domClassFct(this.buttonSelectRoom, "w3-disabled");
        //        //this.UiModder.domAttr.set(this.buttonSelectRoom, "disabled", this.readonly);
        //    }

        //    //  Anmerkung
        //    //
        //    if (this.inputComment != null) {
        //        this.UiModder.domAttr.set(this.inputComment, "disabled", this.readonly);
        //    }

        //    //  Kostenstelle
        //    //
        //    if (this.inputCostCenter != null) {
        //        this.inputCostCenter.set("readonly", this.readonly);
        //    }

        //    //  Meldungsart
        //    //
        //    if (this.inputOccurrenceType != null) {
        //        this.inputOccurrenceType.set("readonly", this.readonly || this.jsonEntity != null);
        //    }

        //}

        //tableSelectableCheck(row) {
        //    return !this.readonly;
        //}

        //_serializeDataHandle: number = null;

        //serializeData_delayed(resetDirtyState, bypassReadonly) {
        //    if (this._serializeDataHandle != null) {
        //        clearTimeout(this._serializeDataHandle);
        //        this._serializeDataHandle = null;
        //    }

        //    this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), 150);
        //}

        //serializeData(resetDirtyState?: boolean, bypassReadonly?: boolean) {

        //    if (this._serializeDataHandle != null) {
        //        clearTimeout(this._serializeDataHandle);
        //        this._serializeDataHandle = null;
        //    }
        //    //dateOfRecord wird einmal direkt gesetzt und kann/darf sich nicht ändern
        //    //selbiges für reporterID - UPDATE: Reporter ist änderbar

        //    let entity = this.inputOccurrenceType.get("selectedEntity");
        //    this.formData.occurrenceTypeID = (entity != null ? entity.ID : null);

        //    entity = this.inputCostCenter.get("value");
        //    this.formData.costCenterID = (entity != null ? this.PitHelper.getEntityAttributeValue(entity, "ID", "json") : null);

        //    //if (this.isAreaNeeded === true)
        //    this.formData.buildingID = this.selectedBuildingID;
        //    this.formData.buildingPartID = this.selectedBuildingPartID;
        //    this.formData.roomID = this.selectedRoomID;
        //    this.formData.levelID = this.selectedLevelID;

        //    this.formData.additionalLocations = [];
        //    for (let i = 0; i < this.additionalLocations.length; i++) {
        //        let addLoc = this.additionalLocations[i];

        //        this.formData.additionalLocations.push(addLoc.data);
        //    }


        //    this.formData.specialConfirmation = this._specialConfirmationStatus;

        //    if (this.currentReporterEntity != null) {
        //        this.formData.reporterID = this.currentReporterEntity.ID;
        //    }

        //    this.formData.isEscalation = this.inputEscalation.checked;

        //    //this.formData.propertyData = (this.propertyTable != null ? this.propertyTable.getData() : null);
        //    this.formData.properties = this.propertiesTable._jsonDataOut;

        //    this.formData.comment = this.inputComment.value;

        //    this.formData.mainOccurrenceID = this.mainOccurrence.ID;

        //    if (resetDirtyState === true) {
        //        this._formDataUndirty = JSON.stringify(this.formData)
        //        //console.log("reset dirtystate", this._formDataUndirty);
        //    }

        //    console.log("serializeData", this.formData, "readonly?", this.readonly);

        //    if (this.readonly == true && bypassReadonly !== true) { // nicht weitermachen wenns schreibgeschützt ist!
        //        return;
        //    }

        //    if (this._formDataUndirty != null) {
        //        this.set("IsDirty", this._formDataUndirty != JSON.stringify(this.formData));
        //    } else {
        //        this.set("IsDirty", this._formDataUndirty == null && this.formData != null);
        //    }

        //    //console.log("serializeData - dirty?", this.formData, this.isDirty);

        //    if (this.isDirty === true && this.continuousSaveMode === true && this.startupState == "ready") {
        //        this.saveOccurrenceData();
        //    }
        //}

        //startup(bReload?: boolean) {
        //    console.log("occurrenceform startup", this.entityID, this.entityGUID, this.jsonEntity, this.startupState);
        //    on(this.taskList, "ExecutersChanged", lang.hitch(this, "_onChanged_TaskExecuters"));
        //    on(this.commentsList, "CommentSaved", lang.hitch(this.taskList, "loadScheduledTaskExecutors"));

        //    //this.additionalLocations = [];
        //    this.removeAdditonalLocation();

        //    this.loadCurrentEmployee();

        //    // falls Datensatz geöffnet wird: laden
        //    if (this.entityGUID != null && this.jsonEntity == null ||
        //        this.entityGUID != null && this.jsonEntity != null && bReload === true) {
        //        this.startupState = "load";
        //        this.loadOccurrence();
        //    }
        //    // neuer Datensatz
        //    else {
        //        this.setDate();

        //        this.inputOccurrenceType._loadListValues();
        //        this.StandbyStop();

        //        this.startupState = "ready";
        //    }

        //    //this.inputOccurrenceType.

        //    //this.UiModder.domClass.remove(this.actionContainer, "w3-hide");

        //}

        //loadCurrentEmployee(): void {
        //    this._isEditor = false;
        //    this.inputReporter.value = this.translations["OccurrenceForm__ReporterLabelDefault"];//"(ich)";

        //    if (this.employee != null) {
        //        this._onGetcurrentEmployee(this.employee);
        //        return;
        //    }

        //    let url = window.appRoot + "Occurrence/GetCurrentEmployeeJSON";

        //    this.RequestManager.post(
        //        url,
        //        {
        //        },
        //        lang.hitch(this, this._onGetcurrentEmployee),
        //        lang.hitch(this, function (error) {
        //            console.error("current employee fehler", error);
        //        }),
        //        false // sync
        //    );
        //}

        //_onGetcurrentEmployee(response) {
        //    this.employee = response;
        //    this.taskList.isExternalEmployee = this.employee.Classname != "Employee";
        //    for (let i = 0; i < response.groupList.length; i++) {
        //        let group = response.groupList[i];

        //        if (group.is_occurrence_group == true) {
        //            this._isEditor = true;
        //            break;
        //        }
        //    }

        //    this._setEditReporterVisibility();

        //    if (this.entityGUID != null && this.jsonEntity == null ||
        //        this.entityGUID != null && this.jsonEntity != null) {

        //    }
        //    // neuer Datensatz
        //    else {
        //        this._setReporterEntity(response);
        //    }
        //}

        //_setAdditionalLocationsVisibility(occurrenceType) {
        //    let bAllowMultipleLocations = false;

        //    console.log("_setAdditionalLocationsVisibility", occurrenceType, "readonly?", this.readonly);

        //    this.UiModder.domClass.add(this.selectAdditionalLocationsContainer, "w3-hide");

        //    if (typeof (occurrenceType) != "undefined" && occurrenceType != null && this.readonly != true) {
        //        if (occurrenceType.is_multiple_locations_selectable === true) {
        //            this.UiModder.domClass.remove(this.selectAdditionalLocationsContainer, "w3-hide");
        //            bAllowMultipleLocations = true;
        //        }
        //    }

        //    if (bAllowMultipleLocations != true) {
        //        this.UiModder.domClass.add(this.sectionAdditionalLocation, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.remove(this.sectionAdditionalLocation, "w3-hide");
        //    }
        //}

        //addLocation(locationEntity: any, label: string, existingOccurrenceID?: string, existingOccurrenceLabel?: string, existingOccurrenceColor?: any) {

        //    console.log("addLocation", locationEntity, label, existingOccurrenceID, existingOccurrenceLabel);

        //    if (locationEntity == null || typeof (locationEntity) == "undefined") {
        //        return;
        //    }

        //    // ein neues "Deskriptorobjekt" machen
        //    // bestehend aus der gewählten Location, vorhandene Meldung und dem HTML-Node

        //    // prüfen obs das schon gibt!
        //    let existingLoc = this._getAdditionalLocationById(locationEntity.ID);
        //    if (existingLoc != null) return; // nicht weitermachen!!

        //    let addLoc = {
        //        data: {
        //            locationEntity: locationEntity,
        //            occurrenceID: null
        //        },
        //        occurrenceLabel: null,
        //        node: null
        //    };

        //    if (existingOccurrenceID != null && typeof (existingOccurrenceID) != "undefined") {
        //        addLoc.data.occurrenceID = existingOccurrenceID;
        //        addLoc.occurrenceLabel = existingOccurrenceLabel;
        //    }

        //    let locButton = this.UiModder.domConstruct.create("a");
        //    this.UiModder.domClass.add(locButton, "w3-padding-small w3-margin-right w3-margin-bottom");
        //    this.UiModder.domAttr.set(locButton, "innerHTML", label);

        //    if (addLoc.data.occurrenceID != null) {
        //        this.UiModder.domClass.add(locButton, "mds-hover-bright");
        //        this.UiModder.domStyle.set(locButton, "backgroundColor", existingOccurrenceColor.BackColor.Hex);
        //        this.UiModder.domAttr.set(locButton, "innerHTML", label + " (" + addLoc.occurrenceLabel + ")");
        //        this.UiModder.domAttr.set(locButton, "textDecoration", "none");
        //        //this.UiModder.domAttr.set(locButton, "href", window.appRoot + "home/Occurrence/view?id=" + addLoc.data.occurrenceID);
        //        this.UiModder.domAttr.set(locButton, "target", "_blank");

        //        let icon = this.UiModder.domConstruct.create("i");
        //        this.UiModder.domClass.add(icon, "fa fa-eye");
        //        //this.UiModder.domStyle.set(icon, "display", "none");
        //        this.UiModder.domStyle.set(icon, "marginLeft", "6px");
        //        this.UiModder.domConstruct.place(icon, locButton);

        //    } else {
        //        this.UiModder.domClass.add(locButton, "w3-hover-red w3-light-gray mds-hover-bright hover-strike");

        //        let icon = this.UiModder.domConstruct.create("i");
        //        this.UiModder.domClass.add(icon, "fa fa-times-circle w3-text-red");
        //        //this.UiModder.domStyle.set(icon, "display", "none");
        //        this.UiModder.domStyle.set(icon, "marginLeft", "6px");
        //        this.UiModder.domConstruct.place(icon, locButton);
        //    }

        //    addLoc.node = locButton;

        //    this.UiModder.domConstruct.place(locButton, this.additionalLocationsContainer);

        //    on(locButton, "click", lang.hitch(this, this._onClick_AdditionalLocation, addLoc))

        //    this.additionalLocations.push(addLoc);
        //}

        //_onClick_AdditionalLocation(locationDescriptor) {
        //    console.log("_onClick_AdditionalLocation", locationDescriptor);

        //    if (this.readonly == true) return;

        //    if (locationDescriptor.data.occurrenceID == null) {
        //        this.removeAdditonalLocation(locationDescriptor.data.locationEntity.ID);
        //        this.serializeData();
        //    } else {
        //        document.occurrenceHome.showOccurrenceDialog(locationDescriptor.data.occurrenceID, false);
        //    }
        //}

        //_onClick_SelectAdditionalLocation(evt) {
        //    if (this.readonly == true) return;

        //    this.selectAdditionalRoom();
        //}

        //selectAdditionalRoom(): void {
        //    let roomDialog = new RoomDialog();
        //    roomDialog.set("callback", lang.hitch(this, "onSelectAdditionalRoom"));
        //    //roomDialog.returnCompleteEntities = true;
        //    roomDialog.set("NeededLayers", this.isAreaNeeded)

        //    roomDialog.selection.level = null;
        //    roomDialog.selection.building = null;
        //    roomDialog.selection.buildingpart = null;
        //    roomDialog.selection.room = null;

        //    roomDialog.set("ok", true);
        //    roomDialog.set("cancel", true);
        //    roomDialog.set("header", /*"Raum bearbeiten"*/this.translations["SelectRoomDialog__Header"]);

        //    roomDialog.show();
        //}

        //onSelectAdditionalRoom(result, selection) {
        //    console.info("onSelectAdditionalRoom", result, selection, this.additionalLocations);

        //    if (result != 1) {
        //        return;
        //    }

        //    let locationEntity = null;
        //    let label = selection._label;

        //    if (selection.room != null) {
        //        locationEntity = { ID: selection.room };
        //    }

        //    else if (selection.level != null) {
        //        // das is dermassen beshit!!
        //        // bei ZAL wird nicht das Stockwerk ausgewählt, sondern nur der StockwerksNAME
        //        // erst in Kombination mit dem Gebäudeteil kann das Backend sich daraus das wirkliche Stockwerk suchen!!
        //        // d.h. hier unbedingt "level"-ID + buildingpart mitgeben!!
        //        locationEntity = { ID: selection.level + ";" + selection.buildingpart };
        //    }

        //    else if (selection.buildingpart != null) {
        //        locationEntity = { ID: selection.buildingpart };
        //    }

        //    else if (selection.building != null) {
        //        locationEntity = { ID: selection.building };
        //    }

        //    else {
        //        return;
        //    }

        //    locationEntity.targettype = selection.targettype;

        //    this.addLocation(locationEntity, label)

        //    if (this.startupState == "ready") {
        //        this.serializeData();
        //    }
        //}

        //removeAdditonalLocation(targetID: string = null;) {
        //    if (typeof (targetID) == "undefined") {
        //        targetID = null;
        //    }

        //    //console.log("removeAdditonalLocation", targetID, this.additionalLocations);

        //    let index = null;

        //    if (targetID != null) {
        //        index = this._getAdditionalLocationIndexById(targetID);
        //    }

        //    for (let i = 0; i < this.additionalLocations.length; i++) {
        //        if (index == null || index == i) {
        //            this.UiModder.domConstruct.destroy(this.additionalLocations[i].node);
        //            if (index != null) {
        //                this.additionalLocations.splice(i, 1);
        //            }
        //        }
        //    }

        //    if (index == null) {
        //        this.additionalLocations = [];
        //    }
        //}

        //_getAdditionalLocationById(ID) {

        //    let index = this._getAdditionalLocationIndexById(ID);
        //    if (index != -1) {
        //        return this.additionalLocations[index];
        //    }
        //    return null;
        //}

        //_getAdditionalLocationIndexById(ID) {
        //    for (let i = 0; i < this.additionalLocations.length; i++) {
        //        let additionalLocation = this.additionalLocations[i];
        //        if (additionalLocation.data.locationEntity.ID == ID) {

        //            return i;
        //        }
        //    }

        //    return -1;
        //}

        //_setEditReporterVisibility(): void {
        //    //console.log("_setEditReporterVisibility - iseditor? readonly?", this._isEditor, this.readonly);

        //    if (this._isEditor === true && (this.readonly != true || (this.jsonEntity != null && this.jsonEntity.isExecuter == true))) {
        //        this.UiModder.domClass.remove(this.btnEditReporter, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.add(this.btnEditReporter, "w3-hide");
        //    }
        //}

        //_setReporterEntity(entity) {
        //    //console.log("_setReporterEntity employee:", entity);
        //    if (typeof (entity.DispName) == "undefined") {
        //        entity.DispName = entity.dispname;
        //    } else if (typeof (entity.dispname) == "undefined") {
        //        entity.dispname = entity.DispName;
        //    }
        //    this.currentReporterEntity = entity;
        //    this.inputReporter.value = entity.dispname;

        //    if (entity.ref_cost_center != null && typeof (entity.ref_cost_center) != "undefined") {
        //        this.inputCostCenter.set("value", entity.ref_cost_center);
        //    }

        //    this.setPhoneNumbers(entity);
        //}

        //setPhoneNumbers(rootObject) {
        //    let bPhone = false;
        //    this.UiModder.domConstruct.empty(this.PhoneNoLabel);
        //    this.UiModder.domConstruct.empty(this.MPhoneNoLabel);
        //    this.UiModder.domClass.add(this.sectionPhoneNo, "w3-hide");
        //    this.UiModder.domClass.add(this.sectionMPhoneNo, "w3-hide");

        //    if (rootObject.Telephone != null && rootObject.Telephone != "") {
        //        this.UiModder.domClass.remove(this.sectionPhoneNo, "w3-hide");

        //        this.UiModder.domConstruct.create("a", {
        //            "href": "tel:" + rootObject.Telephone,
        //            "innerHTML": rootObject.Telephone
        //        }, this.PhoneNoLabel);
        //        //this.UiModder.domAttr.set(this.PhoneNoLabel, "innerHTML", rootObject.Telephone);
        //    }
        //    if (rootObject.Mobile_phone != null && rootObject.Mobile_phone != "") {
        //        this.UiModder.domClass.remove(this.sectionMPhoneNo, "w3-hide");
        //        this.UiModder.domConstruct.create("a", {
        //            "href": "tel:" + rootObject.Mobile_phone,
        //            "innerHTML": rootObject.Mobile_phone
        //        }, this.MPhoneNoLabel);
        //        //this.UiModder.domAttr.set(this.MPhoneNoLabel, "innerHTML", rootObject.Mobile_phone);
        //    }
        //}

        //setDate(): void {
        //    if (this.jsonEntity == null) {
        //        this.formData.dateOfRecord = new Date();

        //    } else {
        //        this.formData.dateOfRecord = new Date(this.jsonEntity.Time);
        //    }

        //    let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        //    let stringDateTime = this.formData.dateOfRecord.toLocaleDateString('de-DE', options);
        //    this.inputDate.value = stringDateTime;
        //}

        //saveOccurrenceData(callback?: Function) {

        //    if (this.continuousSaveMode != true) {
        //        this.StandbyStart();
        //    }

        //    console.log("saveOccurrenceData", this.formData);

        //    let url = window.appRoot + "Occurrence/SaveOccurrenceData";

        //    this.RequestManager.post(
        //        url,
        //        {
        //            entityID: this.entityID,
        //            sJsonData: JSON.stringify(this.formData)
        //        },
        //        lang.hitch(this, "_onSaveOccurrenceDataResponse", callback),
        //        lang.hitch(this, "_onSaveOccurrenceDataError"),
        //        false // sync
        //    );
        //}

        //_onSaveOccurrenceDataResponse(callback, response) {

        //    console.log("_onSaveOccurrenceDataResponse", callback, response);

        //    // in der response steht eine GUID mit der wir das Entity wiederfinden (keine Entity-ID...)

        //    // #17314 wenn es weitere Locations gibt, dann in einem zweiten Request diese verarbeiten
        //    if (this.formData.additionalLocations.length > 0) {
        //        this._saveAdditionalLocations(this.formData.additionalLocations, response.guid, callback)
        //        return;
        //    }

        //    this.isDirty = false;
        //    this._formDataUndirty = this.formData;

        //    if (this.continuousSaveMode != true) {
        //        this.StandbyStop();
        //    }

        //    if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
        //        callback();
        //    }
        //}

        //_onSaveOccurrenceDataError(error) {
        //    if (this.continuousSaveMode != true) {
        //        this.StandbyStop();
        //        this.handleErrorResponse(error.Message);
        //    }

        //    // auch bei live-Speicherung den Benutzer informieren?
        //}

        //_saveAdditionalLocations(locations, occurrenceGUID, callback) {
        //    console.log("_saveAdditionalLocations", locations, occurrenceGUID);

        //    let data = { sourceOccurrenceGUID: occurrenceGUID, additionalLocations: locations };

        //    let url = window.appRoot + "Occurrence/CloneToAditionalLocations";

        //    this.RequestManager.post(
        //        url,
        //        {
        //            sJsonData: JSON.stringify(data)
        //        },
        //        lang.hitch(this, "_onSaveAdditionalLocationsResponse", callback),
        //        lang.hitch(this, "_onSaveAdditionalLocationsError"),
        //        false // sync
        //    );
        //}

        //_onSaveAdditionalLocationsError(error) {
        //    console.error("Zusätzliche Locations wurden nicht gespeichert!!", error.Message);
        //    if (this.continuousSaveMode != true) {
        //        this.StandbyStop();
        //        this.handleErrorResponse("could not save additional locations!<br>" + error.Message);
        //    }

        //    // auch bei live-Speicherung den Benutzer informieren?
        //}

        //_onSaveAdditionalLocationsResponse(callback, response) {

        //    console.log("_onSaveAdditionalLocationsResponse", callback, response);

        //    this.isDirty = false;
        //    this._formDataUndirty = this.formData;

        //    if (this.continuousSaveMode != true) {
        //        this.StandbyStop();
        //    }

        //    if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
        //        callback();
        //    }
        //}

        //loadOccurrence(entityGUID: string = null) {

        //    this.StandbyStart();

        //    let url = window.appRoot + "Occurrence/LoadOccurrenceJSON";

        //    if (entityGUID != null && typeof (entityGUID) != "undefined") {
        //        this.entityGUID = entityGUID;
        //    }

        //    let guid = this.entityGUID;

        //    this.RequestManager.post(
        //        url,
        //        {
        //            occurrenceGUID: guid
        //        },
        //        lang.hitch(this, "_onLoadOccurrenceResponse"),
        //        lang.hitch(this, "_onLoadOccurrenceError"),
        //        false // sync
        //    );
        //}

        //_onLoadOccurrenceResponse(response, bVirtual) {
        //    //this.StandbyStop();
        //    this.jsonEntity = JSON.parse(response);

        //    console.log("_onLoadOccurrenceResponse", this.jsonEntity, bVirtual);

        //    if (this.jsonEntity == null || typeof (this.jsonEntity) == "undefined") {
        //        this.StandbyStop();
        //        alert("requested item does not exist");
        //        return;
        //    }

        //    if (bVirtual != true) {

        //        this.entityID = this.jsonEntity.ID;

        //        this.taskList.occurrenceID = this.entityID;
        //        this.taskList.loadScheduledTaskExecutors();

        //        this.notesList.occurrenceID = this.entityID;
        //        this.notesList.occurrence = this.jsonEntity;
        //        this.notesList.startup(this.jsonEntity.EL_occurrence_note_occurrence);

        //        //this.commentsList.occurrenceID = this.entityID;
        //        //this.commentsList.occurrence = this.jsonEntity;
        //        //this.commentsList.startup(this.jsonEntity.EL_occurrence_comment_occurrence);
        //        ////this.commentsList.enableNewComment(this.jsonEntity.ref_occurrence_status.is_create_reporter_comment == true);

        //        this.occurrenceChildList.occurrenceID = this.entityID;
        //        this.occurrenceChildList.occurrence = this.jsonEntity;
        //        this.occurrenceChildList.occurrenceForm = this;
        //        this.occurrenceChildList.startup(this.jsonEntity.EL_Occurrence_main_occurrence);

        //        //if (this.occurrenceTypesData.length == 0) {
        //        //    this.occurrenceTypesData = [this.jsonEntity.ref_occurrence_type];
        //        //    this._setOccurrenceTypeValues();
        //        //}
        //    }
        //    // Bearbeitbar wenn ich der Meldende bin und der Status dies zulässt
        //    this.set("Readonly", this.jsonEntity.isReadonly); // was auch immer gesetzt ist - einmal ausführen (u.a. wegen Eskalationscheckbox)

        //    this.setFormData(bVirtual);
        //    //this.inputOccurrenceType._loadListValues();

        //    if (bVirtual === true) {
        //        this.StandbyStop();
        //        return;
        //    }

        //    this.emit("EntityChange", this.jsonEntity);

        //    this.StandbyStop();
        //}

        //_onLoadOccurrenceError(error) {
        //    this.StandbyStop();
        //    this.handleErrorResponse(error.Message);
        //}

        //setMainOccurrence(entity?: any) {
        //    let actualEntity = null;
        //    if (typeof (entity) == "undefined") {
        //        actualEntity = this.jsonEntity.ref_main_occurrence;
        //    } else {
        //        actualEntity = entity;
        //    }

        //    this.mainOccurrence = actualEntity;
        //    //console.log("setMainOccurrence", actualEntity);
        //    if (actualEntity == null || typeof (actualEntity) == "undefined") {
        //        this.UiModder.domClass.add(this.sectionMainOccurrence, "w3-hide");
        //    }

        //    if (actualEntity.ID != "") {
        //        //this.UiModder.domAttr.set(this.linkMainOccurrence, "innerHTML", actualEntity.Number);
        //        this.UiModder.domAttr.set(this.labelMainOccurrence, "innerHTML", actualEntity.Number);
        //        this.UiModder.domClass.remove(this.sectionMainOccurrence, "w3-hide");
        //    }

        //    return actualEntity;
        //}


        //setFormData(bVirtual) {
        //    //console.info("setFormData", this.jsonEntity);

        //    //// special: die Eskalation darf nur bei vorhandenen Meldungen angezeigt werden und dort wenn erlaubt
        //    //this.UiModder.domClass.remove(this.sectionEscalation, "w3-hide");

        //    this.UiModder.domClass.add(this.sectionEscalation, "w3-hide");
        //    this.UiModder.domClass.add(this.sectionTasks, "w3-hide"); // Aufträge
        //    this.UiModder.domClass.add(this.sectionChilds, "w3-hide"); // Folgemeldungen
        //    this.UiModder.domClass.add(this.sectionFeedback, "w3-hide");
        //    this.UiModder.domClass.add(this.sectionEditorInfo, "w3-hide");
        //    this.UiModder.domClass.add(this.sectionCancellationInfo, "w3-hide");
        //    this.UiModder.domClass.add(this.sectionNotes, "w3-hide");

        //    if (this.jsonEntity == null) {
        //        return;
        //    }

        //    this.inputReporter.value = this.jsonEntity.ref_reporter.DispName;
        //    this.currentReporterEntity = this.jsonEntity.ref_reporter;

        //    this.setPhoneNumbers(this.jsonEntity.ref_reporter);

        //    if (typeof (this.jsonEntity.EL_Occurrences_of_source_Occurrence) != "undefined") {
        //        for (let i = 0; i < this.jsonEntity.EL_Occurrences_of_source_Occurrence.length; i++) {
        //            let derivedOccurrence = this.jsonEntity.EL_Occurrences_of_source_Occurrence[i];

        //            this.addLocation(derivedOccurrence.ref_managed_object, derivedOccurrence.ref_managed_object.tmp_label, derivedOccurrence.ID, derivedOccurrence.Number, derivedOccurrence.ref_occurrence_status.Coloration);
        //        }
        //    }

        //    if (bVirtual != true) {

        //        this.UiModder.domClass.remove(this.sectionTasks, "w3-hide"); // Aufträge
        //        this.UiModder.domClass.remove(this.sectionChilds, "w3-hide"); // Folgemeldungen
        //        this.UiModder.domClass.remove(this.sectionFeedback, "w3-hide");
        //        this.UiModder.domClass.remove(this.sectionNotes, "w3-hide");
        //        //this.UiModder.domClass.add(this.btnSendNote, "w3-hide");

        //        this.inputEscalation.checked = this.jsonEntity.is_escalation === true;
        //        //if (this.jsonEntity.canEscalate == true || this.jsonEntity.is_escalation === true) {
        //        //    this.UiModder.domClass.remove(this.sectionEscalation, "w3-hide");
        //        //}

        //        if (this.jsonEntity.isExecuter == true) {
        //            this.UiModder.domClass.remove(this.sectionEditorInfo, "w3-hide");
        //            this.UiModder.domClass.remove(this.sectionNotes, "w3-hide");
        //            //this.UiModder.domClass.remove(this.btnSendNote, "w3-hide");
        //        }

        //        if (this.jsonEntity.is_cancellation_requested == true) {
        //            this.UiModder.domClass.remove(this.sectionCancellationInfo, "w3-hide");
        //        }

        //        let mainOcc = this.setMainOccurrence();

        //        let date = new Date(this.jsonEntity.Time);
        //        let options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
        //        this.inputDate.value = date.toLocaleDateString('de-DE', options);

        //        this.inputFeedback.value = this.jsonEntity.feedback;

        //        //this.inputOccurrenceType.selectedValue = this.jsonEntity.ref_occurrence_type.ID; // das führt allerdings zu einem change-Event!


        //        // ID mitgeben, damit die API auf jeden Fall die bereits ausgewählte Meldungsart mitliefert:
        //        let parameter: any = { occurrenceID: this.entityID };


        //        if (mainOcc.ID != "") {
        //            // wenns eine Hauptmeldung gibt, dann muss der API das mitgeteilt werden, weil evtl zusätzliche Meldungsarten daherkommen
        //            parameter.mainOccurrenceID = mainOcc.ID;
        //        }

        //        this.inputOccurrenceType.setAdditionalRequestParams("jsonParameters", JSON.stringify(parameter));


        //    }


        //    if (this.jsonEntity.ref_cost_center2 != null) {
        //        if (this.jsonEntity.ref_cost_center2.ID != "") {
        //            this.inputCostCenter.set("value", this.jsonEntity.ref_cost_center2, true);
        //        }
        //        if (this.jsonEntity.ref_cost_center2.ref_employee != null && typeof (this.jsonEntity.ref_cost_center2.ref_employee.ID) != "undefined") {
        //            //this.inputCostCenterEmployee.value = this.jsonEntity.ref_cost_center2.ref_employee.DispName;
        //            this.inputCostCenterEmployee.value = this.jsonEntity.ref_cost_center2.verantwortlich;
        //        }
        //    }


        //    this.inputComment.value = this.jsonEntity.note;//.replace("\r\n", "<br>");

        //    this.inputOccurrenceType._loadListValues(this.jsonEntity.ref_occurrence_type, true);
        //    this.setSpecialInfoByOccurrenceType(this.jsonEntity.ref_occurrence_type);
        //    this.set("AreaNeeded", this.jsonEntity.ref_occurrence_type.is_show_area_info === true ? this.jsonEntity.ref_occurrence_type.area_level : false);
        //    //this.adjustRoomSelectionState();

        //    let label = "";
        //    let selectedBuildingID = null;
        //    let selectedBPID = null;
        //    let selectedLevelID = null;
        //    let selectedRoomID = null;


        //    switch (this.jsonEntity.ref_managed_object.Classname) {

        //        case "Building":
        //            //label = this.jsonEntity.ref_managed_object.ref_real_estate.OKS_site + " " + this.jsonEntity.ref_managed_object.Name_number
        //            label = this.jsonEntity.ref_managed_object.dispname;
        //            selectedBuildingID = this.jsonEntity.ref_managed_object.ID;
        //            break;

        //        case "Building_part":
        //            //label = this.jsonEntity.ref_managed_object.OKS_buildingpart;
        //            label = this.jsonEntity.ref_managed_object.dispname;
        //            //selectedBPID = this.jsonEntity.ref_managed_object.ID;
        //            selectedBuildingID = this.jsonEntity.ref_managed_object.ref_building.ID;

        //            break;

        //        case "Level":
        //            //label = this.jsonEntity.ref_managed_object.OKS_level;
        //            //label = this.jsonEntity.ref_managed_object.ref_building.ref_real_estate.Name_number + " " + this.jsonEntity.ref_managed_object.ref_level_designation.Name;
        //            label = this.jsonEntity.ref_managed_object.dispname;
        //            selectedLevelID = this.jsonEntity.ref_managed_object.ID;
        //            //selectedBPID = this.jsonEntity.ref_managed_object.ref_building_part.ID;
        //            selectedBuildingID = this.jsonEntity.ref_managed_object.ref_building.ID;
        //            break;

        //        case "Room":
        //            //label = this.jsonEntity.ref_managed_object.OKS_room;
        //            //label = this.jsonEntity.ref_managed_object.Name_number + " (" + this.jsonEntity.ref_managed_object.OKS_room + ")";
        //            label = this.jsonEntity.ref_managed_object.dispname;
        //            selectedRoomID = this.jsonEntity.ref_managed_object.ID;
        //            selectedLevelID = this.jsonEntity.ref_managed_object.ref_level.ID;
        //            //selectedBPID = this.jsonEntity.ref_managed_object.ref_level.ref_building_part.ID;
        //            selectedBuildingID = this.jsonEntity.ref_managed_object.ref_level.ref_building.ID;
        //            break;


        //        default:
        //            label = "???";
        //            break;

        //    }
        //    //console.log("setFormData Roomlabel", label, this.jsonEntity.ref_managed_object);
        //    this.onSelectRoom(1, { building: selectedBuildingID, buildingpart: selectedBPID, level: selectedLevelID, room: selectedRoomID, _label: label });

        //    this._renderPropertiesTable(this.jsonEntity.EL_property_occurence_assignment_occurrence);



        //    if (bVirtual === true) {
        //        this.jsonEntity = null;
        //        this.entityID = null;

        //        this.serializeData();
        //    }

        //    else {
        //        this.serializeData(true); // "nicht dirty" setzen
        //    }

        //    this.startupState = "ready";
        //}

        //loadPropertyList(): void {

        //    this.StandbyStart(this.sectionProperties);

        //    let url = window.appRoot + "Occurrence/LoadOccurrencePropertiesJSON";

        //    let targetID = null;

        //    // bei einer neuen Meldung muss die Liste aus dem angegebenen Meldungstyp geladen werden
        //    if (this.jsonEntity == null) {
        //        targetID = this.formData.occurrenceTypeID;
        //    }

        //    // bei einer bestehenden Meldung kommt die Liste direkt aus der Meldung
        //    else {
        //        targetID = this.jsonEntity.ID;
        //    }

        //    this.RequestManager.post(
        //        url,
        //        {
        //            targetID: targetID
        //        },
        //        lang.hitch(this, "_onLoadPropertyListResponse"),
        //        lang.hitch(this, "_onLoadPropertyListError"),
        //        false // sync
        //    );
        //}

        //_onLoadPropertyListResponse(response) {
        //    this.StandbyStop();
        //    let entitylist = response;
        //    //console.log("_onLoadPropertyListResponse", entitylist);
        //    this._renderPropertiesTable(entitylist);
        //}

        //_onChangeProperties(data) {
        //    //console.log("_onChangeProperties", data);
        //    this.serializeData();
        //}

        //_onLoadPropertyListError(error) {
        //    this.StandbyStop();
        //    this.handleErrorResponse(error.Message);
        //    //alert(error.Message);
        //}

        //_onChangeOccurenceType(selectedValue) {

        //    //console.log("_onChangeOccurenceType", selectedValue, this.inputOccurrenceType.entities);
        //    this._setAdditionalLocationsVisibility(selectedValue);
        //    this.removeAdditonalLocation();
        //    this.onSelectRoom(1, null); // raum zurücksetzen!

        //    this.serializeData();

        //    this.loadPropertyList();

        //    if (selectedValue == "" || selectedValue == null) {
        //        this.set("AreaNeeded", false);
        //        return;
        //    }

        //    this.setSpecialInfoByOccurrenceType(selectedValue);



        //    this.set("AreaNeeded", selectedValue.is_show_area_info === true ? selectedValue.area_level : false);
        //}

        //setSpecialInfoByOccurrenceType(occTypeEntity) {
        //    console.log("setSpecialInfoByOccurrenceType", occTypeEntity, this.entityID);

        //    occTypeEntity.is_show_special_note == true || occTypeEntity.is_show_special_confirmation == true ? this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-hide") : this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-hide");

        //    this.entityID != null ? this.UiModder.domClass.add(this.sectionSpecialInfo, "w3-disabled") : this.UiModder.domClass.remove(this.sectionSpecialInfo, "w3-disabled");

        //    this.setSpecialConfirmation(occTypeEntity.is_show_special_confirmation == true ? occTypeEntity.special_confirmation_text : "");
        //    this.setSpecialNote(occTypeEntity.is_show_special_note == true ? occTypeEntity.special_note : "");

        //}

        //_onChangeComment(): void {
        //    this.serializeData();
        //}

        //_onChangeFeedback(): void {
        //    // feedback derzeit nicht bearbeitbar im Formular
        //}

        //_onChangeCostCenter(selectedEntity) {

        //    //console.log("_onChangeCostCenter", selectedEntity);
        //    if (typeof (selectedEntity) != "undefined" && selectedEntity != null) {
        //        //this.inputCostCenterEmployee.value = selectedEntity.ref_employee.DispName;
        //        this.inputCostCenterEmployee.value = selectedEntity.verantwortlich;
        //    } else {
        //        this.inputCostCenterEmployee.value = null;
        //    }
        //    this.serializeData();
        //}

        //_onClick_EditReporter(evt) {
        //    if (this._isEditor != true || this.readonly == true) { // Rechteprüfung!
        //        return;
        //    }

        //    this.showEditReporter();
        //}

        //setSpecialNote(text) {
        //    if (text == "" || text == null || typeof (text) == "undefined") {
        //        text = "";
        //        this.UiModder.domClass.add(this.tableSpecialNote, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.remove(this.tableSpecialNote, "w3-hide");
        //    }

        //    this.UiModder.domAttr.set(this.txtSpecialNote, "innerHTML", text);
        //}

        //setSpecialConfirmation(text) {
        //    if (text == "" || text == null || typeof (text) == "undefined") {
        //        text = "";
        //        this.isSpecialConfirmationNeeded = false;
        //        this.UiModder.domClass.add(this.tableSpecialConfirmation, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.remove(this.tableSpecialConfirmation, "w3-hide");
        //        this.isSpecialConfirmationNeeded = true;
        //    }

        //    this.setSpecialConfirmationStatus(this.entityID != null);

        //    this.UiModder.domAttr.set(this.txtSpecialConfirmation, "innerHTML", text);
        //}

        //_onClick_SpecialConfirmation(evt) {

        //    if (this.isSpecialConfirmationNeeded != true || this.readonly === true) {
        //        return;
        //    }

        //    //console.debug("_onClick_SpecialConfirmation", this._specialConfirmationStatus);
        //    this.setSpecialConfirmationStatus(this._specialConfirmationStatus !== true);
        //}

        //setSpecialConfirmationStatus(targetState) {
        //    this._specialConfirmationStatus = targetState;
        //    //console.debug("setSpecialConfirmationStatus", targetState);

        //    this.serializeData();

        //    this.setSpecialConfirmationStatusStyle();
        //}

        //setSpecialConfirmationStatusStyle(): void {
        //    if (this.readonly === true) {
        //        this.UiModder.domClass.remove(this.tableSpecialConfirmation, "mds-hover-dark");
        //    } else {
        //        this.UiModder.domClass.add(this.tableSpecialConfirmation, "mds-hover-dark");
        //    }
        //    if (this._specialConfirmationStatus === true) {
        //        this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
        //        this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.remove(this.buttonCheckSpecialConfirmation_Unchecked, "w3-hide");
        //        this.UiModder.domClass.add(this.buttonCheckSpecialConfirmation_Checked, "w3-hide");
        //    }
        //}

        //showEditReporter(bShow: boolean = true) {

        //    this._enableChangeReporter = false;

        //    if (bShow === false) {
        //        this._tmpSelectedReporterEntity = null;

        //        if (this._tmpReporterHintbox != null) {
        //            this._tmpReporterHintbox.destroy();
        //            this._tmpReporterHintbox = null;
        //            this.UiModder.domConstruct.empty(this.editReporterContainer);

        //            this.UiModder.domClass.add(this.editReporterContainer, "w3-hide");
        //            this.UiModder.domClass.remove(this.inputReporter, "w3-hide");
        //            this.UiModder.domClass.remove(this.btnEditReporter, "w3-hide");
        //            this.UiModder.domClass.add(this.btnConfirmReporter, "w3-hide");
        //            this.UiModder.domClass.add(this.btnCancelReporter, "w3-hide");
        //            //this.UiModder.domClass.remove(this.sectionPhoneNo, "w3-hide");
        //            //this.UiModder.domClass.remove(this.sectionMPhoneNo, "w3-hide");
        //        }
        //    } else {
        //        this.UiModder.domClass.add(this.sectionPhoneNo, "w3-hide");
        //        this.UiModder.domClass.add(this.sectionMPhoneNo, "w3-hide");
        //        this.UiModder.domClass.remove(this.editReporterContainer, "w3-hide");
        //        this.UiModder.domClass.add(this.inputReporter, "w3-hide");
        //        this.UiModder.domClass.add(this.btnEditReporter, "w3-hide");
        //        //this.UiModder.domClass.remove(this.btnConfirmReporter, "w3-hide");
        //        this.UiModder.domClass.remove(this.btnCancelReporter, "w3-hide");

        //        let reporterHintbox = new HintBox();

        //        reporterHintbox.set("DataFormat", "json"); // wird für Request und Response benötigt (pithelper)
        //        reporterHintbox.labelAttribute = "DispName";
        //        //reportHintbox.suggestionLabelAttribute = null;
        //        //reportHintbox.filterPath = null;
        //        //reportHintbox.searchParam = null; // name des Parameters im Filter ( => pit-Filter)
        //        reporterHintbox.requestUrlSearchParameter = "searchText"; // name des Parameters der über die Url als Http-Request gesendet wird (=> Controller)
        //        reporterHintbox.resetOnEdit = false; // das Entity zurücksetzen wenn der Benutzer eine Eingabe macht (also Inputfeld irgendwie reintippt)

        //        reporterHintbox.url = "Occurrence/GetPotentialReporters";
        //        reporterHintbox.minLetterCount = 5;

        //        reporterHintbox.setMaxResultsCount(10);

        //        reporterHintbox.setReadonly(false);

        //        reporterHintbox.set("value", this.currentReporterEntity);

        //        this.UiModder.domConstruct.place(reporterHintbox.domNode, this.editReporterContainer);

        //        this._tmpReporterHintbox = reporterHintbox;

        //        on(reporterHintbox, "change", lang.hitch(this, this.continueEditReporter));

        //        reporterHintbox.inputNode.focus();
        //    }
        //}

        //continueEditReporter(data) {
        //    console.log("continueEditReporter", data);

        //    this._tmpSelectedReporterEntity = data;

        //    // BYPASS (ZAL will die Bestätigungsbuttons nicht):
        //    if (this._tmpSelectedReporterEntity != null) {
        //        this._onClickConfirmEditReporter();
        //    }
        //    return;

        //    if (this._tmpSelectedReporterEntity != null) {
        //        this.UiModder.domClass.remove(this.btnConfirmReporter, "w3-disabled");
        //        this.UiModder.domClass.add(this.btnConfirmReporter, "mds-hover-dark");
        //        //this.UiModder.domClass.remove(this.btnCancelReporter, "w3-disabled");
        //        //this.UiModder.domClass.add(this.btnCancelReporter, "mds-hover-dark");
        //        this._enableChangeReporter = true;
        //    } else {
        //        this.UiModder.domClass.add(this.btnConfirmReporter, "w3-disabled");
        //        this.UiModder.domClass.remove(this.btnConfirmReporter, "mds-hover-dark");
        //        //this.UiModder.domClass.add(this.btnCancelReporter, "w3-disabled");
        //        //this.UiModder.domClass.remove(this.btnCancelReporter, "mds-hover-dark");
        //        this._enableChangeReporter = false;
        //    }
        //}

        //_onClickConfirmEditReporter(evt = null) {

        //    if (this._tmpSelectedReporterEntity != null) {
        //        if (this._tmpSelectedReporterEntity.ID != this.currentReporterEntity.ID) {
        //            this._setReporterEntity(this._tmpSelectedReporterEntity);
        //        }
        //    }

        //    this.showEditReporter(false);

        //    this.serializeData(false, true);
        //}

        //_onClickCancelEditReporter(evt) {
        //    this.showEditReporter(false);

        //    this._setReporterEntity(this.currentReporterEntity);
        //}

        //_onClick_MainOccurrence(evt) {
        //    evt.stopPropagation();
        //    let occHome = document.occurrenceHome;
        //    let dlg = occHome.showOccurrenceDialog(this.mainOccurrence.web_guid, true); // ID, readonly
        //}

        //_onClick_SelectRoom(evt) {
        //    this.selectRoom();
        //}

        //selectRoom(): void {
        //    let roomDialog = new RoomDialog();
        //    roomDialog.set("callback", lang.hitch(this, "onSelectRoom"));
        //    roomDialog.extendedData = { "occurrenceType": this.formData.occurrenceTypeID }; // JDM schränkt die auswählbaren Räume und Gebäude nach Meldungsart ein

        //    //console.log("select room, set data", this.formData);
        //    roomDialog.selection.level = this.formData.levelID;
        //    roomDialog.selection.building = this.formData.buildingID;
        //    roomDialog.selection.buildingpart = this.formData.buildingPartID;
        //    roomDialog.selection.room = this.formData.roomID;
        //    //console.log("select room, data is set", roomDialog.selection);

        //    roomDialog.set("NeededLayers", this.isAreaNeeded)

        //    roomDialog.set("ok", true);
        //    roomDialog.set("cancel", true);
        //    roomDialog.set("header", /*"Raum bearbeiten"*/this.translations["SelectRoomDialog__Header"]);

        //    roomDialog.show();
        //}

        //onSelectRoom(result, selection) {
        //    console.info("onSelectRoom", result, selection);

        //    if (result != 1) {
        //        return;
        //    }

        //    let label = "";

        //    if (selection == null || typeof (selection) == "undefined") {
        //        this.selectedBuildingID = null;
        //        this.selectedBuildingPartID = null;
        //        this.selectedLevelID = null;
        //        this.selectedRoomID = null;


        //    } else {

        //        this.selectedBuildingID = selection.building;
        //        this.selectedBuildingPartID = selection.buildingpart;
        //        this.selectedLevelID = selection.level;
        //        this.selectedRoomID = selection.room;

        //        label = selection._label;
        //    }

        //    this.UiModder.domAttr.set(this.labelRoom, "value", label);

        //    this.adjustRoomSelectionState();

        //    if (this.startupState == "ready") {
        //        this.serializeData();
        //    }
        //}

        //_onChangeEscalation(evt) {
        //    this.serializeData();

        //    // wegen schreibschutz wird das entity aber nicht dirty, daher manuell:
        //    if (this.readonly == true) {

        //        if (this._formDataUndirty != null) {
        //            this.set("IsDirty", this._formDataUndirty != JSON.stringify(this.formData));
        //        } else {
        //            this.set("IsDirty", this._formDataUndirty == null && this.formData != null);
        //        }

        //        console.log("changed escalation - dirty?", this.formData, this._formDataUndirty, this.isDirty);
        //    }
        //}

        //_onChanged_TaskExecuters(): void {
        //    this.loadOccurrence();
        //    //this.jsonEntity.isExecuter = true;
        //    //this.occurrenceChildList.startup(); // -> Liste neu laden und der Folgemeldung-Button einblenden
        //    //this.commentsList.startup();
        //}

        //_setAreaNeededAttr(value) {
        //    this.isAreaNeeded = value;
        //    console.log("area neede?", value);
        //    if (this.isAreaNeeded !== false) {
        //        this.UiModder.domClass.remove(this.sectionArea, "w3-hide");
        //    } else {
        //        this.UiModder.domClass.add(this.sectionArea, "w3-hide");

        //        this.formData.selectedBuildingID = null;
        //        this.formData.selectedBuildingPartID = null;
        //        this.formData.selectedLevelID = null;
        //        this.formData.selectedRoomID = null;
        //    }
        //}

        //_setIsDirtyAttr(value) {
        //    //console.log("set dirty", value);
        //    if (this.isDirty != value) {
        //        this.emit("DirtyStateChange", value);
        //        this.isDirty = value;
        //    }
        //}

        //adjustRoomSelectionState(): void {

        //    if (this.isAreaNeeded < 3) {
        //        this.selectedRoomID = null;
        //    }

        //    if (this.isAreaNeeded < 2) {
        //        this.selectedLevelID = null;
        //    }

        //    if (this.isAreaNeeded < 1) {
        //        this.selectedBuildingPartID = null;
        //    }

        //    if (this.isAreaNeeded === false) {
        //        this.selectedRoomID = null;
        //        this.selectedLevelID = null;
        //        this.selectedBuildingPartID = null;
        //        this.selectedBuildingID = null;
        //    }

        //    if ((this.selectedBuildingID == null && this.isAreaNeeded >= 0)
        //        //|| (this.selectedBuildingPartID == null && this.isAreaNeeded >= 1)
        //        || (this.selectedLevelID == null && this.isAreaNeeded >= 2)
        //        || (this.selectedRoomID == null && this.isAreaNeeded >= 3)) {
        //        this.UiModder.domClass.add(this.containerRoom, "w3-border-red w3-pale-red")
        //    }

        //    else {
        //        this.UiModder.domClass.remove(this.containerRoom, "w3-border-red w3-pale-red")
        //    }
        //}

        //_renderPropertiesTable(propertyList) {

        //    this.propertiesTable.isReadonly = this.readonly === true;
        //    this.propertiesTable.set("data", propertyList); // NEUE TABLLE 2021!!

        //    console.log("_renderPropertiesTable", this.readonly, propertyList, this.propertiesTable);

        //    this.UiModder.domConstruct.empty(this.propertiesContainer);

        //    if (propertyList == null || typeof (propertyList) == "undefined") {
        //        this.UiModder.domClass.add(this.sectionProperties, "w3-disabled");
        //        return;
        //    }

        //    this.UiModder.domClass.remove(this.sectionProperties, "w3-disabled");
        //}


        //handleErrorResponse(message) {
        //    if (typeof (this.errorCallback) == "function") {
        //        this.errorCallback(message);
        //        return;
        //    }

        //    // ansonsten Fehlermeldung selber irgendwo platzieren?
        //    //alert(error.Message);
        //}

        //handleSuccessResponse(): void {
        //    if (typeof (this.successCallback) == "function") {
        //        this.successCallback();
        //        return;
        //    }
        //}

        //showComment(commentId) {
        //    this.commentsList.requestComment(commentId);
        //}

        //_onSetPropertyValueResponse(response) {
        //    //console.log("_onSetPropertyValueResponse", response);
        //}

        //_onSetPropertyValueError(error) {
        //    console.error("_onSetPropertyValueError", error);
        //}

    }

Object.assign(OccurrenceFMForm.prototype, {
  templateString: template,
  entityID: null,
  entityGUID: null,
  jsonEntity: null,
  mainOccurrence: { ID: null },
  continuousSaveMode: false,
  isDirty: false,
  _formDataUndirty: null,
  selectedRoomID: null,
  selectedLevelID: null,
  selectedBuildingID: null,
  selectedBuildingPartID: null,
  isAreaNeeded: false,
  additionalLocations: [],
  isSpecialConfirmationNeeded: false,
  _specialConfirmationStatus: null,
  startupState: "new",
  errorCallback: null,
  successCallback: null,
  occurrenceTypesData: null,
  employee: null,
  currentReporterEntity: null,
  _tmpSelectedReporterEntity: null,
  _tmpReporterHintbox: null,
  _enableChangeReporter: false,
  _isEditor: false,
  readonly: false,
  declaredClass: 'OccurrenceFMForm',
});
export default mdsWidget(OccurrenceFMForm, 'WidgetCollection/OccurrenceFM/OccurrenceForm');